<template>
  <div class="ssvip">
    <div class="animation-wapper" v-if="showGif">
      <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation"/>
    </div>
    <template v-if="['1','4'].includes(svipSource)">
      <failure @jumpVip="jumpVip" :svipSource="svipSource" :lockAmount="lockAmount"/>
    </template>
    <template v-else-if="svipSource==='2'">
      <withdraw-wait @jumpVip="jumpVip" @couponAttr="couponAttr" :lockAmount="lockAmount" ref="wait"/>
    </template>
    <template v-else-if="svipSource==='3'">
      <close @jumpVip="jumpVip" :lockAmount="lockAmount"/>
    </template>
    <div class="btn-red btn" @click="showDialog">
      <p v-if="['1','4'].includes(svipSource)">升级SVIP匹配充足资金</p>
      <p v-else-if="svipSource==='2'">激活SVIP免排队</p>
      <p v-else-if="svipSource==='3'">激活SVIP享提现特权通道</p>
    </div>
    <div class="back" @click="giveQueue" v-if="svipSource==='2'">
      <p>放弃排队</p>
    </div>
    <div class="back" @click="back" v-else>
      <p>返回首页</p>
    </div>
    <!-- 活动弹窗 -->
    <withdraw-mao-popup ref="withdrawPop" @judgeOrder="judgeOrder" :status="svipSource"/>
    <!-- 弹窗/有会员状态在支付中 -->
    <nd-dialog
      v-model="waitPayDialog"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-template-content ">
        <div class="title">温馨提示</div>
        <div class="content">
          <p>您有一笔未完成的{{vipsName[payStatusInfo.memberType]}}{{['SC_HY','SC1_HY'].includes(payStatusInfo.memberType)?'SVIP':'VIP'}}支付交易</p>
        </div>
        <div class="button-group">
          <nd-button
            class="btn"
            @click="find(payStatusInfo.goodsCd,'continue')"
          >继续支付</nd-button>
          <div
            class="giveup-btn"
            @click='giveup'
          >放弃支付 </div>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey, judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { fail, wait } from '@/assets/json/index'
import Lottie from 'vue-lottie'
import failure from './components/failure.vue'
import close from './components/close.vue'
import withdrawWait from './components/wait.vue'
import qs from 'qs'
export default {
  name: 'withdraw-svip-middle',
  components: {
    'lottie': Lottie,
    failure,
    close,
    'withdraw-wait': withdrawWait,
    wait
  },
  data () {
    return {
      dialog: false, // 点击开通时弹出
      waitPayDialog: false, // 继续支付弹窗
      payStatusInfo: {}, // 过期数据
      memberGoods: {}, // 弹窗信息
      lockAmount: null, // 锁定额度
      vipsName: {
        'BC_M': '月卡', 
        'BC_HY': '半年卡', 
        'BC_Y': '年卡'
      },
      showGif: null,
      svipSource: this.$route.query.svipSource, // 1 我要提现 未购买权益 2 我要提现 等待审核 3 我要提现 放弃排队 4 我要提现 放款失败 资金不足
      loanApplyNo: this.$route.query.loanApplyNo // 订单编号
    }
  },
  created () {
    this.init()
  },
  watch: {
    dialog (value) {
      this.$report({
        id: 10121,
        args: {
          position: 's_s_vip',
          visible: value ? 1 : 0,
          status: this.svipSource
        }
      })
    }
  },
  destroyed () {
    this.$report({
      id: 10002,
      args: {
        position: 'withdraw-svip-middle',
        visible: 0,
        status: this.svipSource
      }
    })
  },
  methods: {
    ...mapActions('vip', [
      'memberInfo',
      'orderList',
      'orderCancel'
    ]),
    ...mapActions('withdraw', [
      'couponAttr',
      'buySuccess',
      'giveUpQueuinig'
    ]),
    // 初始化
    async init () {
      await Promise.all([this.memberInfoX(), this.couponAttrX()])
      if (this.svipSource === '2') {
        this.showGif = { animationData: wait, loop: false }
      } else {
        this.showGif = { animationData: fail, loop: false }
      }
      this.$report({
        id: 10002,
        args: {
          status: this.svipSource,
          screen: 'withdraw-svip-middle',
          visible: 0
        }
      })
      this.$emit('ready')
    },
    // 放弃排队
    async  giveQueue () {
      await this.giveUpQueuinig({ loanApplyNo: this.loanApplyNo })
      this.$router.replace(
        `/withdraw/svip/middle?svipSource=3&purchaseSVIP=middle`
      )
      window.location.reload()
    },
    handleAnimation (anim) {
      this.anim = anim
    },
    // svip 借款申请 引导页
    async couponAttrX () {
      const res = await this.couponAttr()
      if (res.success) {
        this.ssvipData = res.data
        const { memberGoods, lockAmount } = res.data || {}
        this.memberGoods = memberGoods || {}
        this.lockAmount = lockAmount
      }
    },
    // 跳转vip界面
    jumpVip () {
      const { couponSerialNos, couponType, purchaseSVIP, loanApplyNo, svipSource } = this.$route.query || {}
      let url = `/vip/index?target=svip&purchaseSVIP=${purchaseSVIP}`
      couponSerialNos && (url += `&couponSerialNos=${couponSerialNos}`)
      couponType && (url += `&couponType=${couponType}`)
      svipSource && (url += `&status=${svipSource}`)
      loanApplyNo && (url += `&loanApplyNo=${loanApplyNo}`)
      this.$router.push(url)
    },
    // 初始化
    async  memberInfoX () {
      const { token } = this.$route.query || {}
      let isWait = true
      if (token) {
        const res = await this.memberInfo()
        let { memberGoodsGroupCd } = res.data || {}
        if (res.success) {
          // 如果不是会员 跳前置页
          if (memberGoodsGroupCd === 'SVIP') {
            // if (this.svipSource === '2') {
            //     this.buySuccess({ loanApplyNo: this.loanApplyNo })
            // }
            isWait = false
            this.jumpWithdraw('success')
            this.$report({
              id: 10282,
              args: {
                status: this.svipSource
              }
            })
          }
        }
      }
      if (isWait && this.svipSource === '2') {
        this.$nextTick(() => {
          this.$refs['wait'].getData()
        })
      }
    },
    // 放弃支付
    async giveup () {
      this.$report({
        id: 10284,
        args: {
          status: this.svipSource
        }
      })
      const res = await this.orderCancel({
        orderNo: this.payStatusInfo.exPaySerialNo
      })
      if (res.success) {
        // this.memberInfoX()
        this.waitPayDialog = false
      }
    },
    back () {
      this.$report({
        id: 10284,
        args: {
          status: this.svipSource
        }
      })
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: 'home', exitCurrent: true })
      } else {
        this.$router.push('/')
      }
    },
    // 开通
    showDialog () {
      this.$report({
        id: 10283,
        args: {
          status: 'kai_tong',
          step: this.svipSource
        }
      })
      this.$refs['withdrawPop'].showMao()
    },
    // 放弃特权
    giveUp () {
      this.$report({
        id: 10275,
        args: {
          status: 'fan_qi',
          step: this.svipSource
        }
      })
      this.jumpWithdraw('giveUp')
    },
    // 查看福利
    find (goodsCd, modeOfPayment) {
      let discountPriceValue = ''
      let mode = {}
      if (modeOfPayment === 'continue') {
        const { originalAmount, couponUseDetail, reducedAmount } = this.payStatusInfo || {}
        discountPriceValue = originalAmount
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      this.$refs['withdrawPop'].close()
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = this.getDevice()
      const { discountPrice, memberGoodsGroupCd, memberGoodsCd } = this.memberGoods || {}
      const origin = process.env.VUE_APP_PAYURL
      const channel = getKey('channel') || ''
      const path = '/pay'
      const query = { 
        host,
        gid,
        token,
        channel,
        device,
        modeType: modeOfPayment,
        discountPrice: discountPriceValue || discountPrice,
        memberType: goodsCd || memberGoodsCd,
        memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
        status: this.svipSource,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}&refurl=${window.location.origin}`
      // this.$router.push(
      //   { path: '/vip/middle',
      //     query: {
      //       host,
      //       gid,
      //       token,
      //       device,
      //       modeType: modeOfPayment,
      //       discountPrice: discountPriceValue || discountPrice,
      //       memberType: goodsCd || memberGoodsCd,
      //       memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
      //       status: this.svipSource,
      //       ...mode
      //     } 
      //   }
      // )
    },
    // 是否有已存在订单
    async judgeOrder () {
      this.$report({
        id: 10275,
        args: {
          status: 'gou_mai',
          step: this.svipSource
        }
      })
      this.$refs['withdrawPop'].close()
      const res = await this.orderList({ Status: '' })
      if (res.success) {
        let payStatusInfo = res.data || {}
        if (
          payStatusInfo &&
          payStatusInfo.payStatus &&
          payStatusInfo.payStatus === 'WAIT_PAY'
        ) {
          this.payStatusInfo = payStatusInfo
          this.waitPayDialog = true
        } else {
          this.find()
        }
      }
    },
    routerToVipProtocol () {
      this.$report({
        id: 10019,
        args: { position: 1 }
      })
      this.$refs['withdrawPop'].close()
      this.$router.push('/protocol/vip')
    },
    // 跳转提现界面
    jumpWithdraw (data) {
      const { couponSerialNos, couponType, purchaseSVIP } = this.$route.query || {}
      let purchaseSVIPObj = purchaseSVIP ? { purchaseSuccessSVIP: data } : {}
      let couponSerialNosObj = couponSerialNos ? { couponSerialNos, couponType } : {}
      if (hasNativeMethod('navigateTo') && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: false, ...couponSerialNosObj, ...purchaseSVIPObj })
      } else {
        this.$router.push({ path: '/withdraw/index', query: { ...couponSerialNosObj, ...purchaseSVIPObj } })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.ssvip{
  width: 750px;
  min-height: 100%;
  background: #F7F7F7;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding-bottom:61px;
  padding-top:90px;
  .animation-wapper {
      height: 140px;
      width: 140px;
      margin: 0 auto;
  }
  .wait-color{
    font-size: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .mt9{
    margin-top:9px;
  }
  .mt6{
    margin-top:6px;
  }
  .blue{
    color:#8EB2D8
  }
  .small{
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .ink{
    display: inline-block;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFD8BC;
  }
  .btn{
    width: 650px;
    height: 94px;
    border-radius: 47px;
    margin:50px auto 0;
    font-size: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .btn-red{
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    color: #FFFFFF;
  }
  .back{
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top:50px;
    text-align:center;
  }
  .dialog{
    padding:20px 40px 50px;
    &-title{
      display: flex;
      justify-content:space-between;
      align-items: center;
      height: 45px;
      padding:0 !important;
      &-left{
        font-size: 32px;
        font-weight: 600;
        color: #333333;
      }
      &-right{
        font-size: 24px;
        color: #999999;
      }
    }
    .expire-date{
      position: absolute;
      bottom:160px;
      right:50px;
      width:200px;
      padding:16px ;
      height:60px;
      line-height: 20px;
      background:url('../image/a@2x.png');
      background-size: 100% 100%;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFD8BC;
      text-align: center;
    }
    .fu-li{
      margin-top:20px;
      width: 532px;
      font-size: 28px;
      color: #666666;
    }
    .flex{
      display: flex;
      justify-content:space-between;
      width: 540px;
      margin-top:18px;
    }
    .yuan-jia{
        color: #FFFFFF;
        font-size: 24px;
        text-decoration: line-through;
        padding-right: 20px;
      }
    &-img{
      width: 260px;
      height: 150px;
      background: #FFF7E5;
      border-radius: 10px;
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #763E12;
      display: flex;
      flex-direction: column;
      justify-content:center;
      align-items:center;
      text-align: center;
      >img{
        width:70px;
        height: 70px;
      }
    }
    .gou-mai{
      width: 440px;
      height: 80px;
      line-height: 80px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 40px;
      margin:34px auto 0 !important;
      font-size: 32px;
    }
    .xie-yi{
      font-size: 24px;
      color: #999999;
      text-align:center;
      margin-top:20px;
    }
  }
  .activity-dialog {
    border-radius: 30px;
    .default-content {
      background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%) !important;
      .activity-template-content {
        width: 620px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;

        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #763e12;
          line-height: 45px;
          text-align: center;
        }
        .content {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763e12;
          line-height: 37px;
          padding: 20px 0;
        }
        .btn {
          width: 440px;
          height: 74px;
          line-height: 74px;
          margin-top: 30px;
          background: linear-gradient(270deg, #d79663 0%, #e4b378 100%);
        }
        .giveup-btn {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763e12;
          line-height: 40px;
          text-align: center;
          margin-top: 30px;
        }
        .xy-tips {
          color: #763e12;
          text-align: center;
          margin-top: 30px;
          .active {
            color: #763e12;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>